import introducao from '@/assets/onboarding/introducao.png';
import { ApplicationState } from '@/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './style.scss';

const OnboardingAcknowledgement: React.FC = () => {
        const { strings } = useSelector((state: ApplicationState) => {
            return {
                strings: state.locale.data,
           };
       });
       const history = useHistory();
       const locationState = history.location.state as any;
       
       useEffect(() => {
        if(!locationState || locationState.canRedirect) {
            history.push('/');
        }
        }, []);

       const buttonClickHandler = (): void => {
            history.push('/');
        };

       return (
          <div className="onboardingAcknowledgement">
               <div className="radius">
                   <div className="radius-top">
                        <span className="title">{strings.ONBOARDING.ACKNOWLEDGEMENT}</span>
                        <span>{strings.ONBOARDING.ACKNOWLEDGEMENT_FEEDBACK}</span>
                   </div>

                    <img src={introducao} className="imageFlo" />

                    <span>{strings.ONBOARDING.ACKNOWLEDGEMENT_REMINDER}</span>

                    <button type="button" className="button" onClick={buttonClickHandler}>
                        <span className="buttonText">{strings.ONBOARDING.BOT_LETS_GO.toUpperCase()}</span>
                    </button>
               </div>
          </div>
       )
}

export default OnboardingAcknowledgement;
